<footer class="footer ">
  <div class="container-fluid">
    <div class="copyright pull-right">
      <img src="./assets/eddas/eddas.png" alt="EDDAS" height="13">
    </div>
  </div>
</footer>